import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/status.webp";

const StatutesAndOrdinances = () => {
    const [activeTab, setActiveTab] = useState('statutes-ordinances');

    return (
        <>
            <title>Statutes and Ordinances | ISBM University</title>
            <meta
                name="description"
                content="Explore the statutes, ordinances, and regulations that govern academic, administrative and campus life at ISBM University."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>Statutes and Ordinances</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Statutes and Ordinances
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="statutes-section ptb-50">
                <div className="container-xxl">
                    <h2 className="section-title modern-title text-center text-blue">Statutes and Ordinances</h2>
                    <div className="row m-0">
                        <div className="col-md-4">
                            <div className="statutes-tabs">
                                <div
                                    className={`statutes-tab ${activeTab === 'statutes-ordinances' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('statutes-ordinances')}
                                >
                                    <div className="tab-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
                                        </svg>
                                    </div>
                                    <div className="tab-content">
                                        <h3>Statutes and Ordinances</h3>
                                        <p>Combined university documents</p>
                                    </div>
                                </div>

                                <div
                                    className={`statutes-tab ${activeTab === 'statutes' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('statutes')}
                                >
                                    <div className="tab-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
                                        </svg>
                                    </div>
                                    <div className="tab-content">
                                        <h3>Statutes</h3>
                                        <p>University governing statutes</p>
                                    </div>
                                </div>

                                <div
                                    className={`statutes-tab ${activeTab === 'ordinances' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('ordinances')}
                                >
                                    <div className="tab-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
                                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0z" />
                                        </svg>
                                    </div>
                                    <div className="tab-content">
                                        <h3>Ordinances</h3>
                                        <p>University rules and regulations</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-8">
                            <div className="statutes-tab-content">
                                {activeTab === 'statutes-ordinances' && (
                                    <div className={`tab-pane ${activeTab === 'statutes-ordinances' ? 'active' : ''}`}>
                                        <div className="statutes-card">
                                            <div className="statutes-card-header">
                                                <h2 className="statutes-card-title">Statutes and Ordinances</h2>
                                            </div>
                                            <div className="tab-section-body">
                                                <ul className="document-list">
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">Statutes and Ordinances</span>
                                                            <span className="download-icon">
                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                                </svg> */}
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'statutes' && (
                                    <div className={`tab-pane ${activeTab === 'statutes' ? 'active' : ''}`}>
                                        <div className="statutes-card">
                                            <div className="statutes-card-header">
                                                <h2 className="statutes-card-title">Statutes</h2>
                                            </div>
                                            <div className="tab-section-body">
                                                <ul className="document-list">
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">Statutes</span>
                                                            <span className="download-icon">
                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                                </svg> */}
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'ordinances' && (
                                    <div className={`tab-pane ${activeTab === 'ordinances' ? 'active' : ''}`}>
                                        <div className="statutes-card">
                                            <div className="statutes-card-header">
                                                <h2 className="statutes-card-title">Ordinances</h2>
                                            </div>
                                            <div className="tab-section-body">
                                                <ul className="document-list">
                                                    {/* Ordinance items */}
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">Ordinance - 1</span>
                                                            {/* <span className="download-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                            </svg></span> */}
                                                        </a>
                                                    </li>
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">Ordinance - 2</span>
                                                            {/* <span className="download-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                            </svg></span> */}
                                                        </a>
                                                    </li>
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">Ordinance - 3</span>
                                                            {/* <span className="download-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                            </svg></span> */}
                                                        </a>
                                                    </li>
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">Ordinance - 4</span>
                                                            {/* <span className="download-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                            </svg></span> */}
                                                        </a>
                                                    </li>
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">Ordinance - 5</span>
                                                            {/* <span className="download-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                            </svg></span> */}
                                                        </a>
                                                    </li>
                                                    <li className="document-item">
                                                        <a href="#" className="document-link">
                                                            <span className="document-name">NEP Ordinances</span>
                                                            {/* <span className="download-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                            </svg></span> */}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default StatutesAndOrdinances;